import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import colors from '@/assets/scss/_themes-vars.module.scss'

import PageContainer from '@/components/ui/containers/PageContainer'

import CreateMeetingLinkForm from './containers/CreateMeetingLinkForm'
import { CreateMeetingLinkIntro } from '@/utils/onboarding/intro'
import { useIntro } from '@/hooks/useIntro'
import { IconButton } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export function CreateMeetingLinkPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useIntro(CreateMeetingLinkIntro)

  return (
    <PageContainer>
      <Stack direction="row" alignItems="center" justifyContent="space-between" pb={2}>
          <Stack spacing={1} sx={{ flex: 1, width: '100%' }}>
          <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={3}>
              <IconButton aria-label="back to meeting links" id="previous-button" data-testid="previous-button" onClick={()=>{navigate("/meeting-links")}} size="small" sx={{ mt: '10px' }}>
                <ArrowBackIcon color="primary" fontSize="small" />
              </IconButton>
              <Typography variant="h2" component="div" sx={{ fontSize: { xs: '20px', sm: '20px', lg: '24px' }, lineHeight: '28px', fontWeight: 700, wordWrap: 'break-word' }}>
                {t('page.createMeetingLink.title')}
              </Typography>
            </Stack>
            <Typography
              variant="subtitle1"
              component="div"
              sx={{ color: colors.gray500, fontSize: { xs: '16px', sm: '16px', lg: '18px' }, lineHeight: '22px', fontWeight: 400, wordWrap: 'break-word' }}
            >
              {t('page.createMeetingLink.subtitle')}
            </Typography>
          </Stack>
        </Stack>
      <Paper>
        <Box p={3}>
          <CreateMeetingLinkForm />
        </Box>
      </Paper>
    </PageContainer>
  )
}

export default CreateMeetingLinkPage
